import { scoringConfigSchema, validateNoDuplicateKeys } from "@/scoringUi";

/**
 * Blocking scoring validations from spec 2 section 7, run before an intent
 * (with its entities/criteria) is saved to the scenario. Mirrors
 * cyberjob_client's src/services/scoringValidation.js -- the two host apps
 * share the package's validation functions so their logic can't drift, but
 * each still has to call them at its own save point.
 *
 * Only the per-criterion config check and the duplicate-criterionKey check
 * apply here: the LOCKED-edit check is a client-recruitment-form concern
 * (the admin is the one who SETS "locked", never on the receiving end of it).
 *
 * @param {Array<{scoring?: object}>} intentEntities - entities on the intent being saved
 * @param {Array<Array<{scoring?: object}>>} otherIntentsEntities - entities from every other intent already in the scenario, for the scenario-wide duplicate-key check
 * @returns {string[]}
 */
export function collectScoringValidationErrors(intentEntities, otherIntentsEntities = []) {
    const messages = new Set();

    for (const entity of intentEntities ?? []) {
        const scoring = entity.scoring;
        if (!scoring) continue;
        try {
            scoringConfigSchema.validateSync(scoring, { context: { maxScore: scoring.maxScore }, abortEarly: false });
        } catch (err) {
            for (const message of err.errors ?? [err.message]) messages.add(message);
        }
    }

    const allCriteria = [...(intentEntities ?? []), ...otherIntentsEntities.flat()]
        .filter((e) => e.scoring?.criterionKey)
        .map((e) => ({ criterionKey: e.scoring.criterionKey }));
    const dupError = validateNoDuplicateKeys(allCriteria);
    if (dupError) messages.add(dupError);

    return Array.from(messages);
}
